<template>
  <div>
    <div class="container" v-if="deleteWording">
      <div class="body-no-wording mx-auto flex-mid">
        <img
          v-if="user.pic"
          v-lazy="user.pic"
          :alt="user.firstname"
          :key="user.pic"
          class="image-skeleton reward-image mb-32"
        />
      </div>
    </div>
    <div class="container" v-else>
        <div class="header flex-mid">
          <div>
            <a
              href="https://www.notion.so/happilyai/Insights-Talent-Type-8dded941ece343968466954e585f4d7d"
              target="_blank"
            >
              Happily.ai
            </a>
          </div>
        </div>
        <div class="body mx-auto flex-mid">
          <div>
            <div class="text-title mb-12">Hi {{ user.firstname }},</div>
            <div class="text-des mb-16">
              Thank you for redeeming the {{ user.giftName }} from Happily.
            </div>
            <img
              v-if="user.pic"
              v-lazy="user.pic"
              :alt="user.firstname"
              :key="user.pic"
              class="image-skeleton reward-image mb-32"
            />
            <div v-else class="image-skeleton opa-05 mb-32 mock-reward-image"></div>
            <div class="text-des mb-16">Enjoy!</div>
          </div>
        </div>
        <div class="footer flex-mid">
          <div>
            <div class="flex-mid mb-12">© 2019 Happily.ai</div>
            <div class="flex-mid">Happily.ai ♥ {{ user.company }}</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reward-message",
  data() {
    return {
      user: {
        firstname: "",
        company: "",
        giftName: "",
        pic: ""
      },
      deleteWording: false
    }
  },
  computed: {
    rewardMessageData() {
      return this.$store.getters["reward/rewardMessageData"];
    },
  },
  mounted () {
    if (this.$router.currentRoute.path === "/reward-message" && this.$router.currentRoute.query.code) {
      this.$store.dispatch("reward/getRewardMessage", {code:this.$router.currentRoute.query.code});
    }
    if (
      this.$router.currentRoute.path === "/reward-message" &&
        this.$router.currentRoute.query.deleteWording === "true"
    ) {
      this.deleteWording = true;
    }
  },
  watch: {
    rewardMessageData() {
      let data = this.rewardMessageData['data'];
      if(data && data !== undefined){
        let _this = this
        data.pic = data.secreturl
        this.user = data
        /*this.toDataURL(data.secreturl, function(dataUrl) {
          data.pic = dataUrl
          _this.user = data
          // console.log(dataUrl.replace(/^data:text\/html;base64,/, "data:image\/(png|jpg);base64,"))
        })*/
      }
      document.title = "Reward for " + data.firstname;
    }
  },
  methods: {
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
  background-color: #f2f4f6;
  height: 100vh;
}
.body, .body-no-wording {
  width: calc(100% - 70px);
  max-width: 512px;
  padding: 35px;
}
.body-no-wording {
  padding: 20px;
}
.header {
  height: 72px;
  background-color: #f2f4f6;
}
a {
  font-size: 16px;
  font-weight: bold;
  color: #bbbfc3;
  text-decoration: none;
  text-shadow: 0 1px 0 white;
}
.text-title {
  color: #2F3133;
  font-size: 19px;
  font-weight: 700;
}
.text-des {
  font-size: 16px;
  color: #74787e;
  line-height: 24px;
}
.reward-image {
  width: 100%;
  max-width: 512px;
  max-height: 512px;
}
.mock-reward-image {
  max-width: 512px;
  width: 100%;
  height: calc(100vw - 70px);;
}
.footer {
  height: 130px;
  background-color: #f2f4f6;
  font-size: 12px;
  color: #AEAEAE;
}
</style>